export default __webpack_public_path__ + "static/media/034-sos.ccd7c31e.png";